import HeaderToggle from "./components/HeaderToggle";
import ResortSelect from './components/ResortSelect';
import PointsInput from './components/PointsInput';
import PurchasePrice from './components/PurchasePrice';

import NewContractForm from './components/forms/NewContractForm';
import RefinanceForm from './components/forms/RefinanceForm';

import useContext from '../../context';
import SellerPaysClosingCosts from "./components/SellerPaysClosingCosts";

export default function LoanOptions() {
  const [context] = useContext();

  return (
    <div className="quoteform__column">
      <HeaderToggle />
      <div className="quoteform__heading">Your Contract</div>
      <ResortSelect />
      <PointsInput />
      {
        context.contractType === 'new' && (
          <React.Fragment>
            <SellerPaysClosingCosts />
            <PurchasePrice />
          </React.Fragment>
        )
      }
      <div className="quoteform__purchase-options">
        {
          context.contractType === 'new'
            ? <NewContractForm />
            : <RefinanceForm />
        }
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/index.js